import React, { useContext } from "react";
import clsx from "clsx";
import { Divider, Typography } from "@material-ui/core";

import { Context } from "context";
import styles from './LoginLeftPanel.module.scss'

const LoginLeftPanel = () => {
  const { state: { domainConfig } } = useContext(Context);
  const {
    animatedLogo,
    logoAlt,
    subTitle,
    title,
    themeProvider = "",
  } = domainConfig;

  const vyneTheme = themeProvider === 'Vyne';

  return (
    <div className={clsx(styles.leftContainer, vyneTheme && styles.vyneContainer)}>
      <div className={styles.innerContainer}>
        <img className={styles.logoImage} src={animatedLogo} alt={logoAlt} />

        <Typography className={styles.headingH1} variant="h1">
          {title}
        </Typography>

        <Typography className={styles.subHeading} variant="body1">
          {subTitle}
        </Typography>

        <Divider className={styles.loginDivider} />
      </div>
    </div>
  )
}

export default LoginLeftPanel;